// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__PIxDp","iconCard":"DashboardCard_iconCard__O5u6f"};